import { render } from "./CloseSVG.vue?vue&type=template&id=5ea13ab5&ts=true"
import script from "./CloseSVG.vue?vue&type=script&lang=ts"
export * from "./CloseSVG.vue?vue&type=script&lang=ts"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__